<template>
  <div class="robot">
    <TabBar_m />
    <div class="banner"></div>
    <div class="robot_box">
      <div class="title">
        <h6>Function display</h6>
        <i></i>
        <h3>功能展示</h3>
        <p>
          一毛共享新零售智能安防机器人是远达智能科技全新开发的一款
          多功能机器人。相当于一个集影音娱乐学习、智能贩卖、智能安
          防功能为一体的智能自动售货机。
        </p>
      </div>
      <!-- 机器人模块 -->
      <div class="robot_detail">
        <div class="robot_bgc">
          <img src="../assets/image_m/robot.png" alt />
        </div>
        <ul class="robot_info">
          <li>
            <h3>头部（电子屏）</h3>
            <p>
              机器人头部的电子屏植入了影音娱乐系统，可以满足您随时随地看电影
            </p>
          </li>
          <li>
            <h3>头部（两个麦克风）</h3>
            <p>
              机器人头部植入了两个麦克风，在您需要进行学习时，可以自动进行语音识别，满足您学习、语音输入的需求。
            </p>
          </li>
          <li>
            <h3>头部（全景摄像头）</h3>
            <p>
              机器人头部植入了隐藏式的全景摄像头，摄像头与公安系统联网，当机器人在室内时，该摄像头是隐藏的，不执行任何的功能；当机器人在室外时，全景摄像头就会开始工作，充分发挥安防监控的功能。
            </p>
          </li>
          <li>
            <h3>后脑勺（投影仪）</h3>
            <p>
              机器人的后脑勺相当于一个投影仪，当机器人在户外没有工作时，就会自动寻找一面墙，进行投影）
            </p>
          </li>
          <li>
            <h3>两个手臂（两个音响）</h3>
            <p>
              机器人的两只手臂，相当于两个音响，可以完美地配合机器人的影音、娱乐、学习等功能的实现。
            </p>
          </li>
          <li>
            <h3>肚子（售货机）</h3>
            <p>
              机器人的肚子，相当于一个自动售货机，装满了可以零售的物品，可以实现自动送货、送餐、送快递等需求。
            </p>
          </li>
          <li>
            <h3>两个脚(两个轮子)</h3>
            <p>
              机器人的两个脚，相当于两个智能电动的轮子，可以支撑机器人在一定的区域范围内走动)。
            </p>
          </li>
        </ul>
      </div>

      <!-- 轮播图 -->
      <div class="application">
        <div class="title">
          <h6>Application scenarios</h6>
          <i></i>
          <h3>应用场景</h3>
        </div>

        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide class="item">
            <div class="swiper_img">
              <img src="../assets/image_m/robot_1.png" alt />
            </div>
            <div class="swiper_item_txt">
              <h3>火锅机器人</h3>
              <p>
                火锅机器人的肚子里配置有各种火锅配菜，您可以通过远程点单，实现对火锅机器人的操控，由机器人提供全套的包括锅底、餐具、配菜等的配送，同时提供全流程的火锅蒸煮服务，通过一键实现火锅美味抵达您的舌尖。
              </p>
            </div>
          </swiper-slide>
          <swiper-slide class="item">
            <div class="swiper_img">
              <img src="../assets/image_m/robot_2.png" alt />
            </div>
            <div class="swiper_item_txt">
              <h3>
                木工机器人
                <span>（木工工具、钳工工具）</span>
              </h3>
              <p>
                工具机器人的肚子里配置有各种木工工具、钳工工具，您可以通过远程呼叫，实现对工具机器人的操控，让机器人完成对您所需工具的配送，满足您户外工作、游乐的不时之需。
              </p>
            </div>
          </swiper-slide>
          <swiper-slide class="item">
            <div class="swiper_img">
              <img src="../assets/image_m/robot_3.png" alt />
            </div>
            <div class="swiper_item_txt">
              <h3>助手机器人</h3>
              <p>
                助手机器人主要满足您外出时的生活帮助需求，例如提取重物、旅游拍照等。您可以通过对助手机器人的操控，让机器人满足您在各个场景下的帮助需求。
              </p>
            </div>
          </swiper-slide>
          <swiper-slide class="item">
            <div class="swiper_img">
              <img src="../assets/image_m/robot_4.png" alt />
            </div>
            <div class="swiper_item_txt">
              <h3>送餐机器人</h3>
              <p>
                送餐机器人的肚子里配置有所有外卖的餐饭，完全可以取代送餐员，实现高效快捷送餐。
              </p>
            </div>
          </swiper-slide>
          <swiper-slide class="item">
            <div class="swiper_img">
              <img src="../assets/image_m/robot_5.png" alt />
            </div>
            <div class="swiper_item_txt">
              <h3>送快递机器人</h3>
              <p>
                送快递机器人的肚子里配置有所有取件人的快递，完全可以取代快递员，实现高效快捷送件。
              </p>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <Footer_m />
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
        },
        slidesPerView: 1.6,
        centeredSlides: true,
        loop: true,
        // Some Swiper option/callback...
      },
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.banner {
  background: url("../assets/image_m/robot_banner.png") no-repeat;
  background-position: center;
  background-size: 100%;
  margin-top: 50px;
  &::before {
    padding-top: 100%;
    content: "";
    display: block;
  }
}
.robot_box {
  .title {
    padding: 16px;
    h6 {
      line-height: 15px;
      font-size: 10px;
      text-transform: uppercase;
    }
    i {
      display: block;
      width: 30px;
      height: 2px;
      background: #26acff;
      margin: 4px 0;
    }
    h3 {
      line-height: 25px;
      font-size: 18px;
      margin-bottom: 12px;
    }
    p {
      line-height: 21px;
      font-size: 15px;
    }
  }
  .robot_detail {
    .robot_bgc {
      background: url("../assets/image_m/robot_bgc.png") no-repeat;
      background-position: center;
      background-size: 100%;
      height: 263px;
      width: 303px;
      margin: 0 auto;
      img {
        width: 204px;
        height: 250px;
      }
    }
    .robot_info {
      padding: 16px;
      li {
        padding: 16px 0 16px 25px;
        background: #ffffff;
        border: 1px solid #eaeaea;
        margin-bottom: 8px;
        p {
          line-height: 18px;
          font-size: 12px;
        }
        h3 {
          line-height: 14px;
          font-size: 14px;
          margin-bottom: 4px;
        }
      }
    }
  }
}
//轮播图样式
.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  // -webkit-box-pack: center;
  // -ms-flex-pack: center;
  // -webkit-justify-content: center;
  // justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.8);
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}

.item {
  //width: 231px !important;
  // height: 298px;
  border: 1px solid #eaeaea;
  // background-color: aqua;
  //margin-right: 0 !important;
  .swiper_img {
    img {
      width: 100%;
    }
  }
  .swiper_item_txt {
    padding: 12px 12px 30px 12px;
    h3 {
      line-height: 12px;
      font-size: 14px;
      margin-bottom: 4px;
      span {
        font-size: 12px;
      }
    }
    p {
      line-height: 18px;
      font-size: 12px;
    }
  }
}
</style>